import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
// Local files
import BaseAnalysesListItem from 'components/Analyses/Common/BaseAnalysesListItem/BaseAnalysesListItem';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Item = ({ id, input, status, updated_at }) => { 
  const navigate = useNavigate();
  
  const handleClick = (id) => navigate(`/flow/fl29s/${id}`);

  return (
    <BaseAnalysesListItem
      id={id}
      input={input}
      status={status}
      updated_at={updated_at}
      handleClick={handleClick}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);